import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, fmtDate } from "@/lib/api";
import { usePageMeta, useSite } from "@/lib/store";
import { WRAP } from "@/components/store/Chrome";
import { renderBody } from "@/components/store/Icon";

export default function BlogList() {
  const { site } = useSite();
  const [posts, setPosts] = useState(null);
  usePageMeta(site?.pages?.blog?.title, site?.pages?.blog?.description, site?.pages?.blog?.keywords);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data));
  }, []);
  return (
    <div className={`${WRAP} pt-12`}>
      <p className="label-caps text-[11px] text-red mb-1.5">From the vault</p>
      <h1 className="font-head font-extrabold text-4xl sm:text-5xl tracking-tight border-b-2 border-black pb-4 mb-10">Blog</h1>
      {posts?.length === 0 && <p className="text-[#777] py-16" data-testid="blog-empty">No posts yet.</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14" data-testid="blog-list">
        {posts?.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`} className="group" data-testid={`blog-card-${p.slug}`}>
            {p.cover_image && <div className="aspect-[16/10] bg-white border border-[#e3e3e3] overflow-hidden"><img src={p.cover_image} alt="" className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" /></div>}
            <p className="label-caps text-[10px] text-[#888] mt-4">{fmtDate(p.published_at).split(",")[0]}</p>
            <h2 className="font-head font-extrabold text-xl mt-1.5 group-hover:text-red transition-colors">{p.title}</h2>
            <p className="text-sm text-[#666] mt-2 line-clamp-3">{p.summary}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function PostView({ post }) {
  return (
    <article className="max-w-3xl">
      <p className="label-caps text-[11px] text-red mb-2">{post.published_at ? fmtDate(post.published_at).split(",")[0] : "Draft"}</p>
      <h1 className="font-head font-extrabold text-4xl sm:text-5xl tracking-tight leading-tight" data-testid="blog-post-title">{post.title}</h1>
      {post.summary && <p className="text-lg text-[#666] mt-4">{post.summary}</p>}
      {post.cover_image && <img src={post.cover_image} alt="" className="w-full mt-8 border border-[#e3e3e3]" />}
      <div className="prose-vrv mt-10 text-[#222]" data-testid="blog-post-body">{renderBody(post.body)}</div>
    </article>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(false);
  usePageMeta(post && `${post.title} | Vinyl Record Vault`, post?.seo_description || post?.summary);
  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setErr(true));
  }, [slug]);
  if (err) return <div className={`${WRAP} py-32 text-center`}>Post not found.</div>;
  return <div className={`${WRAP} pt-12`}>{post ? <PostView post={post} /> : <div className="h-96 animate-pulse bg-white/60" />}</div>;
}
